<ng-select
  name="items"
  [multiple]="true"
  [addTag]="true"
  [items]="items"
  [(ngModel)]="selectedItemsList"
  [loading]="isLoading"
  [placeholder]="'emailselect.placeholder' | translate"
  notFoundText=""
  [searchable]="false"
  [clearable]="false"
  [closeOnSelect]="false"
  dropdownPosition="bottom"
  (change)="onSelectionChange()"
  [class.is-invalid]="!valid">
  <ng-template
    *ngIf="items?.length > 0"
    ng-label-tmp
    let-item="item"
    let-clear="clear">
    <span class="ng-value-label u-font-size-16">{{ item }}</span>
    <span
      class="ng-value-icon right u-font-size-16"
      (click)="clear(item)"
      >×</span
    >
  </ng-template>
  <ng-template ng-header-tmp>
    <div class="o-grid--small">
      <div class="o-grid__item col-9">
        <input
          type="email"
          id="email"
          name="email"
          #email="ngModel"
          [(ngModel)]="emailInput"
          class="c-input c-input--gamma" />
      </div>
      <div class="o-grid__item col-3">
        <button
          class="button--xs button-primary button-block"
          type="button"
          [disabled]="!email.value"
          (click)="onAddEmail()">
          {{ "button.add" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
  <ng-template
    *ngIf="items?.length > 1"
    ng-footer-tmp>
    <div class="o-grid--small">
      <div class="o-grid__item col-6">
        <button
          (click)="onSelectAll()"
          class="button--xs button-primary"
          type="button">
          {{ "button.selectall" | translate }}
        </button>
      </div>
      <div class="o-grid__item col-6">
        <button
          (click)="onClearAll()"
          class="button--xs button-secondary"
          type="button">
          {{ "button.unselectall" | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-select>
